import { render, staticRenderFns } from "./taskViewForm.vue?vue&type=template&id=2b8edc5a&scoped=true&"
import script from "./taskViewForm.vue?vue&type=script&lang=js&"
export * from "./taskViewForm.vue?vue&type=script&lang=js&"
import style0 from "./taskViewForm.vue?vue&type=style&index=0&id=2b8edc5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8edc5a",
  null
  
)

export default component.exports